import { jwtDecode } from "jwt-decode";

export const getToken = () => {
  const token = localStorage.getItem("token");

  if (!token) return null;

  try {
    const decoded = jwtDecode(token);

    const currentTime = Date.now() / 1000; // in seconds

    if (decoded.exp && decoded.exp > currentTime) {
      return token;
    } else {
      // Token expired
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      return null;
    }
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const getUserRole = () => {
  const token = localStorage.getItem("token");
  
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
  
    return decoded.sub.role || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const getUserName = () => {
  const token = localStorage.getItem("token");
  
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
  
    return decoded.sub.username || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("userInfo");
  window.location.assign('/');  // Ensures full page reload
};
